export function FinalInvitation() {
  return (
    <section
      data-testid="believing-happy-final-section"
      className="relative bg-[#FAFAF8]"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-10 py-24 md:py-28 text-center reveal">
        <h2
          data-testid="believing-happy-final-headline"
          className="font-display text-[34px] sm:text-[44px] lg:text-[50px] leading-[1.16] tracking-tight text-[#1C1917]"
        >
          What if this is the part where you stop waiting to feel more like
          yourself?
        </h2>

        <div className="mt-6 space-y-2 text-lg md:text-xl leading-relaxed text-[#57534E] max-w-2xl mx-auto">
          <p>You don&rsquo;t need a new life.</p>
          <p>You don&rsquo;t need to know exactly where this will lead.</p>
          <p>
            You just need to be willing to get curious about what you want,
            make room for what you discover and begin.
          </p>
        </div>

        <div className="mt-9 max-w-xl mx-auto">
          <p
            data-testid="believing-happy-final-statement"
            className="font-display italic text-2xl md:text-3xl leading-snug text-[#1C1917]"
          >
            Your life doesn&rsquo;t have to look different to everyone else.
          </p>
          <p className="mt-1 font-display italic text-2xl md:text-3xl leading-snug text-[#159E9A]">
            It has to feel different to you.
          </p>
        </div>
      </div>
    </section>
  );
}
